/**
 * Error thrown when producte details don't exists.
 */
export class ProductNotExistsError implements Error {
    name: string;
    message: string;
    stack: string | undefined;

    constructor() {
        this.name = "ProductNotExistsError";
        this.message = "";
    }
    
}
